export default {
    comment: 'Комментарии',

    delivery: {
        address: {
            placeholder: 'Введите индекс',
            noIndex: 'Нет индекса',
            pvz: 'ПВЗ',
            city: 'Город',
            street: 'Улица',
            house: 'д.',
            housing: 'к.',
            building: 'стр.',
            apartment: 'кв.',
            kladr: 'Кладр',
            fias: 'ФИАС',
            postcode: 'Индекс',
        },
        main: {
            title: 'Доставка',
            printTorg: 'Печать ТОРГ-12',
            printTag: 'Печать этикеток',
            pvz: 'ПВЗ',
            address: 'Адрес доставки',
        },
        courier: {
            courier: 'Курьер',
            name: 'Имя курьера',
            phone: 'Номер телефона курьера',
        },
        intake: {
            status: 'Статус',
            id: 'ID',
            dateCreate: 'Дата создания',
        },
    },

    fields: {
        paymentDate: 'Дата поступления платежа',
        planDate: 'Планируемая дата',
    },

    order: {
        acceptance: 'Невозможно получить АПП',
        main: {
            title: 'Основная информация',
            message: 'Вы действительно хотите изменить способ оплаты?',
        },
        status: {
            auto: 'Автоматически по истечению',
            customer: 'Отменен покупателем',
            waiting: 'В ожидании',
        },
        user: {
            'true': 'Авторизован',
            'false': 'Не авторизован',
        },
    },

    fieldsView: {
        id: 'Заказ №',
        partnerOrderId: 'Номер заказа партнера',
        orderSourceTypeId: 'Источник заказа',
        orderStatusId: 'Статус обработки',
        commentClient: 'Клиента',
        orderCommentWorker: 'Сотрудника магазина',
        deliveryComment: 'Для службы доставки',
        reasonCancel: 'Причина отмены',
        customerRequests: 'Согласование изменений с клиентом',
        promoCode: 'Промокод',
        commentToCustomer: 'Комментарий клиенту',
        name: 'Имя клиента',
        userAuthorization: 'Статус пользователя',
        phone: 'Контактный телефон клиента',
        email: 'Контактный email клиента',
        fullNameReciever: 'ФИО получателя',
        phoneReciever: 'Телефон получателя',
        payTypeId: 'Способ оплаты',
        payStatusId: 'Статус оплаты',
        planDateIssued: 'Планируемая дата самовывоза',
        waitReason: 'Причина ожидания',
        pfm: 'Номер магазина',
        deliveryServiceId: 'Способ доставки',
        clientSurname: 'Фамилия',
        clientName: 'Имя',
        clientPatronymic: 'Отчество',
        deliveryClientPhone: 'Телефон',
        acceptanceActNumber: 'Номер АПП',
        deliveryStatusId: 'Статус доставки',
        desiredDate: 'Желаемая дата доставки покупателю',
        deliveryIndex: 'Адрес доставки',
        isTest: 'Тестовый',
        loyaltyCardNumber: 'Карта лояльности',
        receiveStatusId: 'Статус получения платежа',
        confirmationCode: 'Статус проверки кода',
        document: 'Документы',
        paymentNumber: 'Номер платежа',
        paymentDate: 'Дата поступления платежа',
        languageId: 'Язык сообщений',
        refundReason: 'Причина возврата',
        refundType: 'Способ возврата средств',
        checkingAccount: 'Расчетный счет',
        bankName: 'Наименование банка',
        bik: 'БИК',
        correspondentAccount: 'Корреспондентский счет',
        countCall: 'Количество попыток дозвона',
        productsForAdults: 'Есть товары 18+',
        deliveryServiceTypeId: 'Тип доставки',
        deliveryTrack: 'Трек-номер',
        intake: 'Заявка на забор',
    },
};
